import axios from 'axios';

const setting = {
  timeout: 0, // 타임아웃 없음 (서버 소켓 타임아웃 70분이 제한)
};

//token이 필요없는 request에서 사용
export const instance = axios.create(setting);
